import { render, staticRenderFns } from "./TaskLog.vue?vue&type=template&id=36c4aa04&scoped=true"
import script from "./TaskLog.vue?vue&type=script&lang=js"
export * from "./TaskLog.vue?vue&type=script&lang=js"
import style0 from "./TaskLog.vue?vue&type=style&index=0&id=36c4aa04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4aa04",
  null
  
)

export default component.exports